var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgInfoBluei = function SvgInfoBluei(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 1358"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M0 12a12 12 0 1 1 12 12A12 12 0 0 1 0 12m2.57 0A9.43 9.43 0 1 0 12 2.57 9.44 9.44 0 0 0 2.57 12m7.72 5.16v-4.95a1.71 1.71 0 0 1 3.42 0v4.95a1.71 1.71 0 0 1-3.42 0m.49-9.07a1.8 1.8 0 0 1-.5-1.22 2 2 0 0 1 .04-.34 1.2 1.2 0 0 1 .1-.31 1.4 1.4 0 0 1 .16-.3c.06-.1.13-.18.2-.26a1.8 1.8 0 0 1 2.43 0c.08.08.14.17.2.26a1.7 1.7 0 0 1 .17.3 1.3 1.3 0 0 1 .1.3 4 4 0 0 1 .03.35A1.7 1.7 0 0 1 12 8.6a1.82 1.82 0 0 1-1.22-.5z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInfoBluei);
export default ForwardRef;